import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setParams = useCallback(
    (params: Record<string, string>) => {
      Object.entries(params).forEach(([key, value]) => {
        searchParams.set(key, value);
      });
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  const deleteParams = useCallback(
    (keys: string[]) => {
      keys.forEach((key) => searchParams.delete(key));
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams],
  );

  return { setParams, deleteParams };
};
